import React, {useEffect, useRef} from "react";
import {useTranslation} from "react-i18next";

// Styles
import "./user_demographic_information.scss";

const UserDemographicInfo = ({
    survey,
    demographicInfo,
    setDemographicInfo,
    demographicErrors,
    mandatoryRefs,
}) => {
    const { t } = useTranslation();
    const requiredRefs = useRef({}); // only for mandatory fields

    const handleDemographicChange = (info, value) => {
        setDemographicInfo((prev) => {
            const existingIndex = prev.findIndex(
                (item) => item.demographic_information_id === info.id
            );

            if (existingIndex !== -1) {
                const updated = [...prev];
                updated[existingIndex] = {
                    ...updated[existingIndex],
                    answer: value,
                };
                return updated;
            }

            return [
                ...prev,
                {
                    demographic_information_id: info.id,
                    is_mandatory: info.is_mandatory,
                    option_field_name: info?.option?.field_name,
                    answer: value,
                },
            ];
        });
    };

    useEffect(() => {
        if (mandatoryRefs.length) {
            mandatoryRefs = mandatoryRefs.filter(ref => ref.className.includes("invalid"));

            if (!mandatoryRefs.length) {
                const firstErrorId = Object.keys(demographicErrors).find(
                    (id) => requiredRefs.current[id]
                );
                if (firstErrorId) {
                    requiredRefs.current[firstErrorId]?.current.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }
        }
    }, [demographicErrors]);

    return (
        <div className="single_sect invalid">
            <h3 className="single_sect_primary_text">
                {t("About You")}
            </h3>
            <section className={`validation_sect demographic_info`}>
                <div className="demographic_info_wrapper">
                    {
                        survey?.demographic_informations?.map((info) => {
                            const isRequired = info.is_mandatory;

                            // Only create a ref if the field is required
                            if (isRequired && !requiredRefs.current[info.id]) {
                                requiredRefs.current[info.id] = React.createRef();
                            }

                            return (
                                <div ref={isRequired ? requiredRefs.current[info.id] : null} className={`validation_sect`} key={info.id}>
                                    <h3 className="single_sect_primary_text single_sect_smaller_text">
                                        {t(info?.option?.label)}
                                        {
                                            isRequired ?
                                            <sup>*</sup> : ""
                                        }
                                    </h3>
                                    <div className="input_field demographic_input_field">
                                        <input
                                            name={info?.option?.field_name}
                                            type="text"
                                            placeholder={t("Please add an answer...")}
                                            value={
                                                demographicInfo.find((item) =>
                                                    item.demographic_information_id === info.id
                                                )?.answer || ""
                                            }
                                            onChange={(e) =>
                                                handleDemographicChange(
                                                    info,
                                                    e.target.value
                                                )
                                            }
                                        />
                                    </div>
                                    <div className="error_sect">
                                        {
                                            demographicErrors[info.id] && (
                                                <p className="error_text">{demographicErrors[info.id]}</p>
                                            )
                                        }
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </section>
        </div>
    )
}

export default UserDemographicInfo;